import { TextFieldWithCheckboxDE } from "../common/TextFieldWithCheckboxDE";

export type BooleanFields<T> = {
  [K in keyof T]: T[K] extends boolean | null ? K : never;
}[keyof T];
export type NumberFields<T> = {
  [K in keyof T]: T[K] extends number | null ? K : never;
}[keyof T];

type ProcessDataTextFieldWithCheckboxProps<T> = {
  textFieldValue: number | null | undefined;
  checkboxValue?: boolean | null | undefined;
  textField?: NumberFields<T>;
  textFieldLabel?: string;
  checkboxLabel?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onChangeCheckbox?: (checked: boolean) => void;
  onChangeTextfield?: (text: string) => void;
  onBlur?: () => void;
};

export const ProcessDataTextFieldWithCheckbox = <T,>({
  textFieldValue,
  checkboxValue,
  textField,
  textFieldLabel,
  checkboxLabel,
  disabled,
  readOnly = false,
  onChangeCheckbox = () => {},
  onChangeTextfield = () => {},
  onBlur = () => {},
}: ProcessDataTextFieldWithCheckboxProps<T>) => {
  return (
    <TextFieldWithCheckboxDE
      textFieldLabel={textFieldLabel || String(textField)}
      disabledTextField={disabled}
      checkboxLabel={checkboxLabel}
      textFieldValue={textFieldValue || null}
      checkboxValue={checkboxValue || false}
      onChangeCheckbox={(e) => onChangeCheckbox(e.target.checked)}
      onChangeTextField={(event) => {
        if (!readOnly && textField && event.target.value) {
          onChangeTextfield(event.target.value);
        }
      }}
      onBlur={() => {
        if (!readOnly) {
          onBlur();
        }
      }}
    />
  );
};
